/**
 * Mock result data and preview renderer for service pages.
 * Uses the same XimilarResults.render() output that real users see after upload,
 * so marketing/preview sections are faithful to the actual product UI.
 */
(function (window) {
    'use strict';

    const BASE_CARD_IMG = '/uploads/2026/09/original_6aa5711163131_1789227281.jpg';
const CROP_EXAMPLE_BEFORE = '/assets/images/services/crop-example-before.webp';
const CROP_EXAMPLE_AFTER = '/assets/images/services/crop-example-after.webp';

    // Per-service image overrides — services whose mock data is a slab must
    // show a slab photo, not a raw card (slab-id was pairing "Jordan Fleer"
    // OCR text with a Pikachu photo).
    const SERVICE_IMAGES = {
        'slab-id': '/assets/images/slabs/s-l1600 (19).webp',
        'slab-grade': '/assets/images/slabs/s-l1600 (15).webp',
    };

    // Per-card-type image overrides for AI card grading pages
    const CARD_TYPE_IMAGES = {
        'baseball': '/assets/images/cards/mantle_52_topps.webp',
        'basketball': '/assets/images/cards/grant_hill_2021_prizm_black_90.webp',
        'football': '/assets/images/cards/ohtani_psa_10.webp',
        'hockey': '/assets/images/cards/patrick_roy.webp',
        'soccer': '/assets/images/cards/soccer-logo.webp',
        'mma': '/assets/images/cards/mma-logo.webp',
        'pokemon': '/assets/images/cards/pokemon-hero.webp',
        'magic-the-gathering': '/assets/images/cards/magic-the-gathering-hero.webp',
        'yugioh': '/assets/images/cards/yugioh-hero.webp',
        'one-piece': '/assets/images/cards/one-piece-hero.webp',
        'lorcana': '/assets/images/cards/lorcana-hero.webp',
        'flesh-and-blood': '/assets/images/cards/flesh-and-blood-hero.webp',
        'digimon': '/assets/images/cards/digimon-hero.webp',
        'dragon-ball-super': '/assets/images/cards/dragon-ball-super-hero.webp',
        'star-wars-unlimited': '/assets/images/cards/star-wars-unlimited-hero.webp',
        'weiss-schwarz': '/assets/images/cards/weiss-schwarz-hero.webp',
        'vanguard': '/assets/images/cards/vanguard-hero.webp',
        'marvel-champions': '/assets/images/cards/marvel-champions-hero.webp'
    };

    const MOCK_PRICING = {
        graded: {
            stats_type: 'graded',
            value: {
                mean: 284.50,
                median: 275.00,
                min: 215.00,
                max: 425.00,
                q1: 240.00,
                q3: 315.00,
                latest: 290.00,
                latest_date: '2026-06-15',
                count: 47,
                trend: {
                    slope_per_day: 2.35,
                    volatility: 0.08,
                    r_squared: 0.82,
                    forecast_30d: 345.00
                }
            }
        },
        ungraded: {
            stats_type: 'ungraded',
            value: {
                mean: 42.00,
                median: 38.50,
                min: 18.00,
                max: 95.00,
                q1: 28.00,
                q3: 52.00,
                latest: 39.00,
                latest_date: '2026-06-18',
                count: 128,
                trend: {
                    slope_per_day: 0.15,
                    volatility: 0.14,
                    r_squared: 0.61,
                    forecast_30d: 44.00
                }
            }
        },
        overall: {
            stats_type: 'overall',
            value: {
                mean: 87.30,
                median: 72.00,
                min: 15.00,
                max: 425.00,
                q1: 35.00,
                q3: 145.00,
                latest: 79.00,
                latest_date: '2026-06-19',
                count: 175,
                trend: {
                    slope_per_day: 0.42,
                    volatility: 0.22,
                    r_squared: 0.55,
                    forecast_30d: 92.00
                }
            }
        }
    };

    const MOCK_LISTINGS = [
        {
            name: '2021 Panini Prizm Black #90 Grant Hill PSA 9',
            price: 325.00,
            currency: 'USD',
            source: 'eBay',
            item_link: 'https://www.ebay.com',
            grade: '9',
            grade_company: 'PSA',
            version: 'Non-Foil',
            date_of_creation: '2026-06-20'
        },
        {
            name: 'Grant Hill 2021 Prizm Black #90 BGS 9.5',
            price: 410.00,
            currency: 'USD',
            source: 'COMC',
            item_link: 'https://www.comc.com',
            grade: '9.5',
            grade_company: 'BGS',
            version: 'Non-Foil',
            date_of_creation: '2026-06-15'
        },
        {
            name: '2021 Panini Prizm Black Grant Hill #90 Raw',
            price: 35.00,
            currency: 'USD',
            source: 'Mercari',
            item_link: 'https://www.mercari.com',
            version: 'Non-Foil',
            date_of_creation: '2026-06-21'
        },
        {
            name: 'Grant Hill 2021 Prizm Black #90 PSA 8',
            price: 210.00,
            currency: 'USD',
            source: 'eBay',
            item_link: 'https://www.ebay.com',
            grade: '8',
            grade_company: 'PSA',
            version: 'Non-Foil',
            date_of_sale: '2026-06-10'
        }
    ];

    const MOCK_IDENTIFICATION = {
        full_name: 'Grant Hill 2021 Panini Prizm Black #90',
        name: 'Grant Hill 2021 Panini Prizm Black #90',
        year: '2021',
        set_name: 'Panini Prizm',
        set: 'Panini Prizm',
        card_number: '90',
        card_no: '90',
        company: 'Panini',
        team: 'Detroit Pistons',
        card_type: 'Base',
        sub_set: 'Black',
        links: {
            'eBay': 'https://www.ebay.com',
            'COMC': 'https://www.comc.com',
            'Beckett': 'https://www.beckett.com'
        }
    };

    const MOCK_STATUS = {
        code: 200,
        text: 'OK',
        request_id: 'preview-abc-123',
        processing_time: '3200'
    };

    const mocks = {
        grade:         {
            "_status": {
                "code": 200,
                "text": "OK",
                "request_id": "37fcf97d-bfd0-417a-a887-725552b3bdfd"
            },
            "_id": "ed9da5ce-a4bf-45db-96b9-af29e9618f39",
            "_width": 1200,
            "_height": 1600,
            "grades": {
                "final": 8,
                "corners": 7.5,
                "edges": 9.5,
                "surface": 6.5,
                "centering": 8,
                "condition": "Near Mint"
            },
            "final_grade_label": "Near Mint",
            "damaged": {
                "value": "OK",
                "confidence": 0.92381,
                "is_damaged": false
            },
            "autograph": {
                "value": "Yes",
                "confidence": 0.63381,
                "has_autograph": true
            },
            "side": {
                "value": "Front",
                "confidence": 0.92815
            },
            "category": {
                "value": "Card/Trading Card Game",
                "confidence": 0.99922
            },
            "corners": [
                {
                    "name": "UPPER_LEFT",
                    "grade": 5.5,
                    "point": [
                        298,
                        371
                    ],
                    "bound_box": [
                        272,
                        345,
                        346,
                        419
                    ]
                },
                {
                    "name": "UPPER_RIGHT",
                    "grade": 8.5,
                    "point": [
                        916,
                        361
                    ],
                    "bound_box": [
                        867,
                        335,
                        941,
                        409
                    ]
                },
                {
                    "name": "DOWN_RIGHT",
                    "grade": 8.5,
                    "point": [
                        953,
                        1287
                    ],
                    "bound_box": [
                        904,
                        1238,
                        978,
                        1312
                    ]
                },
                {
                    "name": "DOWN_LEFT",
                    "grade": 7.5,
                    "point": [
                        281,
                        1277
                    ],
                    "bound_box": [
                        255,
                        1228,
                        329,
                        1302
                    ]
                }
            ],
            "edges": [
                {
                    "name": "UPPER",
                    "grade": 9.5,
                    "polygon": [
                        [
                            349,
                            345
                        ],
                        [
                            864,
                            335
                        ],
                        [
                            864,
                            412
                        ],
                        [
                            349,
                            422
                        ]
                    ]
                },
                {
                    "name": "RIGHT",
                    "grade": 9,
                    "polygon": [
                        [
                            864,
                            412
                        ],
                        [
                            941,
                            412
                        ],
                        [
                            978,
                            1235
                        ],
                        [
                            901,
                            1235
                        ]
                    ]
                },
                {
                    "name": "DOWN",
                    "grade": 9.5,
                    "polygon": [
                        [
                            332,
                            1225
                        ],
                        [
                            901,
                            1235
                        ],
                        [
                            901,
                            1312
                        ],
                        [
                            332,
                            1302
                        ]
                    ]
                },
                {
                    "name": "LEFT",
                    "grade": 9.5,
                    "polygon": [
                        [
                            272,
                            422
                        ],
                        [
                            349,
                            422
                        ],
                        [
                            332,
                            1225
                        ],
                        [
                            255,
                            1225
                        ]
                    ]
                }
            ],
            "surface": {
                "grade": 6.5
            },
            "centering": {
                "grade": 8,
                "left_right": "44/56",
                "top_bottom": "53/47",
                "bound_box": [
                    21,
                    28,
                    644,
                    901
                ],
                "pixels": [
                    21,
                    28,
                    27,
                    25
                ],
                "offsets": [
                    0.032,
                    0.031,
                    0.0413,
                    0.0279
                ]
            },
            "card": {
                "name": "CARD",
                "_tags": {
                    "Side": [
                        {
                            "id": "3ebc6fc4-41d4-4432-99f1-5f8c50f10413",
                            "name": "Front",
                            "prob": 0.92815
                        }
                    ],
                    "Damaged": [
                        {
                            "id": "8d77cbf2-96de-4e45-b518-ea09cf77483a",
                            "name": "OK",
                            "prob": 0.92381
                        }
                    ],
                    "Category": [
                        {
                            "id": "089fa0cd-a399-4c6c-8420-d52a55c0ff02",
                            "name": "Card/Trading Card Game",
                            "prob": 0.99922
                        }
                    ],
                    "Autograph": [
                        {
                            "id": "00058dcb-592a-4504-9794-2097f24100f7",
                            "name": "Yes",
                            "prob": 0.63381
                        }
                    ]
                },
                "polygon": [
                    [
                        298,
                        371
                    ],
                    [
                        916,
                        361
                    ],
                    [
                        953,
                        1287
                    ],
                    [
                        281,
                        1277
                    ]
                ],
                "surface": {
                    "grade": 6.5
                },
                "bound_box": [
                    249,
                    316,
                    985,
                    1333
                ],
                "centering": {
                    "grade": 8,
                    "pixels": [
                        21,
                        28,
                        27,
                        25
                    ],
                    "offsets": [
                        0.032,
                        0.031,
                        0.0413,
                        0.0279
                    ],
                    "bound_box": [
                        21,
                        28,
                        644,
                        901
                    ],
                    "left/right": "44/56",
                    "top/bottom": "53/47"
                },
                "identification": {
                    "name": "Pikachu ex",
                    "full_name": "Pikachu ex Ascended Heroes (ASC) #277 ",
                    "year": 2026,
                    "set_name": "Ascended Heroes",
                    "sub_set": null,
                    "card_number": "277",
                    "company": null,
                    "team": null,
                    "links": {
                        "tcgplayer.com": "https://www.tcgplayer.com/product/676089",
                        "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Pikachu+ex+ASC+%23277&_sacat=2536"
                    },
                    "set": "Ascended Heroes",
                    "set_code": "ASC",
                    "set_series_code": null,
                    "series": "Mega Series",
                    "rarity": "Special Illustration Rare",
                    "color": null,
                    "type": null,
                    "card_type": null,
                    "out_of": null
                },
                "listings": [
                    {
                        "img_link": "https://i.ebayimg.com/images/g/aSYAAeSwFx9qpHGG/s-l1600.jpg",
                        "item_id": "v1|287580917526|0",
                        "item_link": "https://www.ebay.com/itm/287580917526",
                        "name": "PIKACHU ex 2026 Pokemon Ascended Heroes #277 Special Illustration Rare PSA 10",
                        "price": 950,
                        "currency": "USD",
                        "country_code": "US",
                        "source": "eBay",
                        "date_of_creation": "2026-09-11",
                        "date_of_sale": null,
                        "grade_company": "PSA",
                        "grade": 10,
                        "version": "Foil/Holo",
                        "variation": null
                    },
                    {
                        "img_link": "https://i.ebayimg.com/images/g/7A4AAeSwO2tqoqla/s-l1600.jpg",
                        "item_id": "v1|287578132940|0",
                        "item_link": "https://www.ebay.com/itm/287578132940",
                        "name": "Pokemon Pikachu EX Ascended Heroes 277 Special Illustration Rare PSA 9 Mint",
                        "price": 343,
                        "currency": "USD",
                        "country_code": "US",
                        "source": "eBay",
                        "date_of_creation": "2026-09-10",
                        "date_of_sale": null,
                        "grade_company": "PSA",
                        "grade": 9,
                        "version": "Foil/Holo",
                        "variation": null
                    }
                ],
                "price_stats": [
                    {
                        "stats_type": "graded",
                        "interval": "overall",
                        "start_date": null,
                        "value": {
                            "q1": 469.99,
                            "q3": 1500,
                            "max": 5599,
                            "min": 299,
                            "std": 1070.85,
                            "mean": 1238.5,
                            "range": 5300,
                            "trend": {
                                "r_squared": 0.295,
                                "span_days": 211,
                                "volatility": 0.865,
                                "data_points": 93,
                                "forecast_30d": 363.61,
                                "trimmed_mean": 1023.22,
                                "slope_per_day": -7.8463,
                                "slope_per_day_pct": -0.013099
                            },
                            "latest": 599,
                            "median": 965,
                            "oldest": 5599,
                            "volume": 93,
                            "latest_date": "2026-09-14",
                            "oldest_date": "2026-02-15"
                        }
                    },
                    {
                        "stats_type": "overall",
                        "interval": "overall",
                        "start_date": null,
                        "value": {
                            "q1": 442.99,
                            "q3": 1417.25,
                            "max": 5599,
                            "min": 134.39,
                            "std": 1008.44,
                            "mean": 1099.4,
                            "range": 5464.61,
                            "trend": {
                                "r_squared": 0.086,
                                "span_days": 211,
                                "volatility": 0.917,
                                "data_points": 116,
                                "forecast_30d": 487.29,
                                "trimmed_mean": 896.93,
                                "slope_per_day": -3.7236,
                                "slope_per_day_pct": -0.006216
                            },
                            "latest": 599,
                            "median": 712.5,
                            "oldest": 5599,
                            "volume": 116,
                            "latest_date": "2026-09-14",
                            "oldest_date": "2026-02-15"
                        }
                    },
                    {
                        "stats_type": "ungraded",
                        "interval": "overall",
                        "start_date": null,
                        "value": {
                            "q1": 365,
                            "q3": 607.91,
                            "max": 1799,
                            "min": 134.39,
                            "std": 312.47,
                            "mean": 536.97,
                            "range": 1664.61,
                            "trend": {
                                "r_squared": 0.018,
                                "span_days": 201,
                                "volatility": 0.582,
                                "data_points": 23,
                                "forecast_30d": 575.48,
                                "trimmed_mean": 488.85,
                                "slope_per_day": 0.8494,
                                "slope_per_day_pct": 0.001544
                            },
                            "latest": 550,
                            "median": 480,
                            "oldest": 565.84,
                            "volume": 23,
                            "latest_date": "2026-09-05",
                            "oldest_date": "2026-02-16"
                        }
                    }
                ],
                "alternatives": [
                    {
                        "set": "Gym Challenge",
                        "set_code": "G2",
                        "card_number": "56",
                        "name": "Sabrinas Hypno",
                        "out_of": "132",
                        "rarity": "Uncommon",
                        "series": "Gym",
                        "type": "Pokemon",
                        "color": "Psychic",
                        "year": 2000,
                        "full_name": "Sabrinas Hypno Gym Challenge (G2) #56",
                        "subcategory": "Pokemon",
                        "links": {
                            "tcgplayer.com": "https://www.tcgplayer.com/product/88879",
                            "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=274324",
                            "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Sabrinas+Hypno+G2+%2356&_sacat=2536"
                        }
                    },
                    {
                        "set": "Surging Sparks",
                        "set_code": "SSP",
                        "card_number": "247",
                        "name": "Pikachu ex",
                        "out_of": "191",
                        "rarity": "Hyper Rare",
                        "series": "Scarlet & Violet",
                        "set_series_code": "sv7",
                        "year": 2024,
                        "full_name": "Pikachu ex Surging Sparks (SSP) #247",
                        "subcategory": "Pokemon",
                        "links": {
                            "tcgplayer.com": "https://www.tcgplayer.com/product/593169",
                            "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=794621",
                            "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Pikachu+ex+SSP+%23247&_sacat=2536"
                        }
                    },
                    {
                        "set": "Phantasmal Flames",
                        "set_code": "PFL",
                        "card_number": "43",
                        "name": "Milcery",
                        "out_of": "094",
                        "rarity": "Common",
                        "series": "Mega Evolution Series",
                        "year": 2025,
                        "full_name": "Milcery Phantasmal Flames (PFL) #43",
                        "subcategory": "Pokemon",
                        "links": {
                            "tcgplayer.com": "https://www.tcgplayer.com/product/662196",
                            "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=857618",
                            "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Milcery+PFL+%2343&_sacat=2536"
                        }
                    },
                    {
                        "set": "Mega Evolution",
                        "set_code": "MEG",
                        "card_number": "182",
                        "name": "Mega Kangaskhan ex",
                        "out_of": "132",
                        "rarity": "Special Illustration Rare",
                        "series": "Mega Evolution Series",
                        "year": 2025,
                        "full_name": "Mega Kangaskhan ex Mega Evolution (MEG) #182",
                        "subcategory": "Pokemon",
                        "links": {
                            "tcgplayer.com": "https://www.tcgplayer.com/product/654521",
                            "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=851253",
                            "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Mega+Kangaskhan+ex+MEG+%23182&_sacat=2536"
                        }
                    }
                ]
            },
            "_points": [
                [
                    298.2557678222656,
                    371.7651062011719
                ],
                [
                    916.404541015625,
                    361.2530212402344
                ],
                [
                    953.603515625,
                    1287.466796875
                ],
                [
                    281.9521789550781,
                    1277.525146484375
                ]
            ],
            "_objects": [
                {
                    "id": "e0f155e9-2978-4524-bae2-3d7d3377c2c4",
                    "name": "Card",
                    "prob": 0.83203125,
                    "bound_box": [
                        249,
                        316,
                        985,
                        1333
                    ]
                }
            ],
            "sport_id": null,
            "sport_id_error": null,
            "tcg_id": {
                "_status": {
                    "code": 200,
                    "text": "OK",
                    "request_id": "9b01a3e2-bc1f-4669-b1dc-de3793fb32ed"
                },
                "category": "Card/Trading Card Game",
                "card": {
                    "confidence": 0.946138322353363,
                    "tags": {
                        "category": {
                            "name": "Card/Trading Card Game",
                            "confidence": 1
                        },
                        "side": {
                            "name": "front",
                            "confidence": 0.99915
                        },
                        "subcategory": {
                            "name": "Pokemon",
                            "confidence": 0.99997
                        },
                        "autograph": null,
                        "foil_holo": {
                            "name": "Other Rare/Promo",
                            "confidence": 0.99307
                        },
                        "graded": {
                            "name": "no",
                            "confidence": 0.93322
                        },
                        "damaged": null,
                        "alphabet": {
                            "name": "latin",
                            "confidence": 0.99923
                        }
                    },
                    "identification": {
                        "name": "Pikachu ex",
                        "full_name": "Pikachu ex Ascended Heroes (ASC) #277 ",
                        "year": 2026,
                        "set_name": "Ascended Heroes",
                        "sub_set": null,
                        "card_number": "277",
                        "company": null,
                        "team": null,
                        "links": {
                            "tcgplayer.com": "https://www.tcgplayer.com/product/676089",
                            "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Pikachu+ex+ASC+%23277&_sacat=2536"
                        },
                        "set": "Ascended Heroes",
                        "set_code": "ASC",
                        "set_series_code": null,
                        "series": "Mega Series",
                        "rarity": "Special Illustration Rare",
                        "color": null,
                        "type": null,
                        "card_type": null,
                        "out_of": null
                    },
                    "listings": [
                        {
                            "img_link": "https://i.ebayimg.com/images/g/aSYAAeSwFx9qpHGG/s-l1600.jpg",
                            "item_id": "v1|287580917526|0",
                            "item_link": "https://www.ebay.com/itm/287580917526",
                            "name": "PIKACHU ex 2026 Pokemon Ascended Heroes #277 Special Illustration Rare PSA 10",
                            "price": 950,
                            "currency": "USD",
                            "country_code": "US",
                            "source": "eBay",
                            "date_of_creation": "2026-09-11",
                            "date_of_sale": null,
                            "grade_company": "PSA",
                            "grade": 10,
                            "version": "Foil/Holo",
                            "variation": null
                        },
                        {
                            "img_link": "https://i.ebayimg.com/images/g/7A4AAeSwO2tqoqla/s-l1600.jpg",
                            "item_id": "v1|287578132940|0",
                            "item_link": "https://www.ebay.com/itm/287578132940",
                            "name": "Pokemon Pikachu EX Ascended Heroes 277 Special Illustration Rare PSA 9 Mint",
                            "price": 343,
                            "currency": "USD",
                            "country_code": "US",
                            "source": "eBay",
                            "date_of_creation": "2026-09-10",
                            "date_of_sale": null,
                            "grade_company": "PSA",
                            "grade": 9,
                            "version": "Foil/Holo",
                            "variation": null
                        }
                    ],
                    "price_stats": [
                        {
                            "stats_type": "graded",
                            "interval": "overall",
                            "start_date": null,
                            "value": {
                                "q1": 469.99,
                                "q3": 1500,
                                "max": 5599,
                                "min": 299,
                                "std": 1070.85,
                                "mean": 1238.5,
                                "range": 5300,
                                "trend": {
                                    "r_squared": 0.295,
                                    "span_days": 211,
                                    "volatility": 0.865,
                                    "data_points": 93,
                                    "forecast_30d": 363.61,
                                    "trimmed_mean": 1023.22,
                                    "slope_per_day": -7.8463,
                                    "slope_per_day_pct": -0.013099
                                },
                                "latest": 599,
                                "median": 965,
                                "oldest": 5599,
                                "volume": 93,
                                "latest_date": "2026-09-14",
                                "oldest_date": "2026-02-15"
                            }
                        },
                        {
                            "stats_type": "overall",
                            "interval": "overall",
                            "start_date": null,
                            "value": {
                                "q1": 442.99,
                                "q3": 1417.25,
                                "max": 5599,
                                "min": 134.39,
                                "std": 1008.44,
                                "mean": 1099.4,
                                "range": 5464.61,
                                "trend": {
                                    "r_squared": 0.086,
                                    "span_days": 211,
                                    "volatility": 0.917,
                                    "data_points": 116,
                                    "forecast_30d": 487.29,
                                    "trimmed_mean": 896.93,
                                    "slope_per_day": -3.7236,
                                    "slope_per_day_pct": -0.006216
                                },
                                "latest": 599,
                                "median": 712.5,
                                "oldest": 5599,
                                "volume": 116,
                                "latest_date": "2026-09-14",
                                "oldest_date": "2026-02-15"
                            }
                        },
                        {
                            "stats_type": "ungraded",
                            "interval": "overall",
                            "start_date": null,
                            "value": {
                                "q1": 365,
                                "q3": 607.91,
                                "max": 1799,
                                "min": 134.39,
                                "std": 312.47,
                                "mean": 536.97,
                                "range": 1664.61,
                                "trend": {
                                    "r_squared": 0.018,
                                    "span_days": 201,
                                    "volatility": 0.582,
                                    "data_points": 23,
                                    "forecast_30d": 575.48,
                                    "trimmed_mean": 488.85,
                                    "slope_per_day": 0.8494,
                                    "slope_per_day_pct": 0.001544
                                },
                                "latest": 550,
                                "median": 480,
                                "oldest": 565.84,
                                "volume": 23,
                                "latest_date": "2026-09-05",
                                "oldest_date": "2026-02-16"
                            }
                        }
                    ],
                    "alternatives": [
                        {
                            "set": "Gym Challenge",
                            "set_code": "G2",
                            "card_number": "56",
                            "name": "Sabrinas Hypno",
                            "out_of": "132",
                            "rarity": "Uncommon",
                            "series": "Gym",
                            "type": "Pokemon",
                            "color": "Psychic",
                            "year": 2000,
                            "full_name": "Sabrinas Hypno Gym Challenge (G2) #56",
                            "subcategory": "Pokemon",
                            "links": {
                                "tcgplayer.com": "https://www.tcgplayer.com/product/88879",
                                "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=274324",
                                "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Sabrinas+Hypno+G2+%2356&_sacat=2536"
                            }
                        },
                        {
                            "set": "Surging Sparks",
                            "set_code": "SSP",
                            "card_number": "247",
                            "name": "Pikachu ex",
                            "out_of": "191",
                            "rarity": "Hyper Rare",
                            "series": "Scarlet & Violet",
                            "set_series_code": "sv7",
                            "year": 2024,
                            "full_name": "Pikachu ex Surging Sparks (SSP) #247",
                            "subcategory": "Pokemon",
                            "links": {
                                "tcgplayer.com": "https://www.tcgplayer.com/product/593169",
                                "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=794621",
                                "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Pikachu+ex+SSP+%23247&_sacat=2536"
                            }
                        },
                        {
                            "set": "Phantasmal Flames",
                            "set_code": "PFL",
                            "card_number": "43",
                            "name": "Milcery",
                            "out_of": "094",
                            "rarity": "Common",
                            "series": "Mega Evolution Series",
                            "year": 2025,
                            "full_name": "Milcery Phantasmal Flames (PFL) #43",
                            "subcategory": "Pokemon",
                            "links": {
                                "tcgplayer.com": "https://www.tcgplayer.com/product/662196",
                                "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=857618",
                                "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Milcery+PFL+%2343&_sacat=2536"
                            }
                        },
                        {
                            "set": "Mega Evolution",
                            "set_code": "MEG",
                            "card_number": "182",
                            "name": "Mega Kangaskhan ex",
                            "out_of": "132",
                            "rarity": "Special Illustration Rare",
                            "series": "Mega Evolution Series",
                            "year": 2025,
                            "full_name": "Mega Kangaskhan ex Mega Evolution (MEG) #182",
                            "subcategory": "Pokemon",
                            "links": {
                                "tcgplayer.com": "https://www.tcgplayer.com/product/654521",
                                "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=851253",
                                "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Mega+Kangaskhan+ex+MEG+%23182&_sacat=2536"
                            }
                        }
                    ]
                }
            },
            "tcg_id_error": null,
            "detection": {
                "name": "Card",
                "confidence": 0.83203125,
                "bound_box": [
                    249,
                    316,
                    985,
                    1333
                ]
            },
            "_full_url_card": "https://s3-eu-west-1.amazonaws.com/ximilar-tmp-images/card-grading/a09cbe80-5785-4af8-b1c9-791ba2c1b880.webp",
            "_exact_url_card": "/uploads/2026/09/exact_6aa57127ef5ea.jpg?v=1789227304",
            "_clean_url_card": "/uploads/2026/09/clean_6aa5712800de8.jpg?v=1789227304",
            "_img_url": "https://s3-eu-west-1.amazonaws.com/ximilar-tmp-images/card-grading/ee62c15f-a136-4c6a-8cae-57310205c9a6.webp",
            "_url": null,
            "_center_bound_box": [
                21,
                28,
                644,
                901
            ],
            "_crop_bound_box": null,
            "_crop_width": null,
            "_crop_height": null,
            "visualization_url": null,
            "annotated_image_url": "/uploads/2026/09/annotated_6aa57127e495c.jpg?v=1789227304",
            "_images": {
                "corner_details": [
                    "/uploads/2026/09/corner_tl_6aa5712644350.webp?v=1789227304",
                    "/uploads/2026/09/corner_tr_6aa571266592b.webp?v=1789227304",
                    "/uploads/2026/09/corner_bl_6aa5712686aa2.webp?v=1789227304",
                    "/uploads/2026/09/corner_br_6aa57126a5dc1.webp?v=1789227304"
                ],
                "edge_details": [
                    "/uploads/2026/09/edge_left_6aa57126dce28.webp?v=1789227304",
                    "/uploads/2026/09/edge_right_6aa571273cc67.webp?v=1789227304",
                    "/uploads/2026/09/edge_top_6aa571278183f.webp?v=1789227304",
                    "/uploads/2026/09/edge_bottom_6aa57127bd319.webp?v=1789227304"
                ],
                "annotated": "/uploads/2026/09/annotated_6aa57127e495c.jpg?v=1789227304",
                "full": "/uploads/2026/09/full_6aa57127ebc4a.jpg?v=1789227304",
                "exact": "/uploads/2026/09/exact_6aa57127ef5ea.jpg?v=1789227304",
                "cropped": "/uploads/2026/09/cropped_6aa57127f1d84.jpg?v=1789227304",
                "clean": "/uploads/2026/09/clean_6aa5712800de8.jpg?v=1789227304"
            },
            "back_image_url": null,
            "versions": {
                "edges": "ac144d3d_2",
                "final": "5d12cc01_2-ac144d3d_2-7ba660de_11-5bb1214a_4-segmentor-segmentor",
                "points": "segmentor",
                "corners": "5d12cc01_2",
                "surface": "7ba660de_11",
                "centering": "5bb1214a_4",
                "detection": "segmentor"
            },
            "original_image_url": "/uploads/2026/09/original_6aa5711163131_1789227281.jpg",
            "_statistics": {
                "time_stats": {
                    "GenericProcessor": 3.2
                }
            },
            "identification": {
                "name": "Pikachu ex",
                "full_name": "Pikachu ex Ascended Heroes (ASC) #277 ",
                "year": 2026,
                "set_name": "Ascended Heroes",
                "sub_set": null,
                "card_number": "277",
                "company": null,
                "team": null,
                "links": {
                    "tcgplayer.com": "https://www.tcgplayer.com/product/676089",
                    "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Pikachu+ex+ASC+%23277&_sacat=2536"
                },
                "set": "Ascended Heroes",
                "set_code": "ASC",
                "set_series_code": null,
                "series": "Mega Series",
                "rarity": "Special Illustration Rare",
                "color": null,
                "type": null,
                "card_type": null,
                "out_of": null
            },
            "listings": [
                {
                    "img_link": "https://i.ebayimg.com/images/g/aSYAAeSwFx9qpHGG/s-l1600.jpg",
                    "item_id": "v1|287580917526|0",
                    "item_link": "https://www.ebay.com/itm/287580917526",
                    "name": "PIKACHU ex 2026 Pokemon Ascended Heroes #277 Special Illustration Rare PSA 10",
                    "price": 950,
                    "currency": "USD",
                    "country_code": "US",
                    "source": "eBay",
                    "date_of_creation": "2026-09-11",
                    "date_of_sale": null,
                    "grade_company": "PSA",
                    "grade": 10,
                    "version": "Foil/Holo",
                    "variation": null
                },
                {
                    "img_link": "https://i.ebayimg.com/images/g/7A4AAeSwO2tqoqla/s-l1600.jpg",
                    "item_id": "v1|287578132940|0",
                    "item_link": "https://www.ebay.com/itm/287578132940",
                    "name": "Pokemon Pikachu EX Ascended Heroes 277 Special Illustration Rare PSA 9 Mint",
                    "price": 343,
                    "currency": "USD",
                    "country_code": "US",
                    "source": "eBay",
                    "date_of_creation": "2026-09-10",
                    "date_of_sale": null,
                    "grade_company": "PSA",
                    "grade": 9,
                    "version": "Foil/Holo",
                    "variation": null
                }
            ],
            "price_stats": [
                {
                    "stats_type": "graded",
                    "interval": "overall",
                    "start_date": null,
                    "value": {
                        "q1": 469.99,
                        "q3": 1500,
                        "max": 5599,
                        "min": 299,
                        "std": 1070.85,
                        "mean": 1238.5,
                        "range": 5300,
                        "trend": {
                            "r_squared": 0.295,
                            "span_days": 211,
                            "volatility": 0.865,
                            "data_points": 93,
                            "forecast_30d": 363.61,
                            "trimmed_mean": 1023.22,
                            "slope_per_day": -7.8463,
                            "slope_per_day_pct": -0.013099
                        },
                        "latest": 599,
                        "median": 965,
                        "oldest": 5599,
                        "volume": 93,
                        "latest_date": "2026-09-14",
                        "oldest_date": "2026-02-15"
                    }
                },
                {
                    "stats_type": "overall",
                    "interval": "overall",
                    "start_date": null,
                    "value": {
                        "q1": 442.99,
                        "q3": 1417.25,
                        "max": 5599,
                        "min": 134.39,
                        "std": 1008.44,
                        "mean": 1099.4,
                        "range": 5464.61,
                        "trend": {
                            "r_squared": 0.086,
                            "span_days": 211,
                            "volatility": 0.917,
                            "data_points": 116,
                            "forecast_30d": 487.29,
                            "trimmed_mean": 896.93,
                            "slope_per_day": -3.7236,
                            "slope_per_day_pct": -0.006216
                        },
                        "latest": 599,
                        "median": 712.5,
                        "oldest": 5599,
                        "volume": 116,
                        "latest_date": "2026-09-14",
                        "oldest_date": "2026-02-15"
                    }
                },
                {
                    "stats_type": "ungraded",
                    "interval": "overall",
                    "start_date": null,
                    "value": {
                        "q1": 365,
                        "q3": 607.91,
                        "max": 1799,
                        "min": 134.39,
                        "std": 312.47,
                        "mean": 536.97,
                        "range": 1664.61,
                        "trend": {
                            "r_squared": 0.018,
                            "span_days": 201,
                            "volatility": 0.582,
                            "data_points": 23,
                            "forecast_30d": 575.48,
                            "trimmed_mean": 488.85,
                            "slope_per_day": 0.8494,
                            "slope_per_day_pct": 0.001544
                        },
                        "latest": 550,
                        "median": 480,
                        "oldest": 565.84,
                        "volume": 23,
                        "latest_date": "2026-09-05",
                        "oldest_date": "2026-02-16"
                    }
                }
            ],
            "alternatives": [
                {
                    "set": "Gym Challenge",
                    "set_code": "G2",
                    "card_number": "56",
                    "name": "Sabrinas Hypno",
                    "out_of": "132",
                    "rarity": "Uncommon",
                    "series": "Gym",
                    "type": "Pokemon",
                    "color": "Psychic",
                    "year": 2000,
                    "full_name": "Sabrinas Hypno Gym Challenge (G2) #56",
                    "subcategory": "Pokemon",
                    "links": {
                        "tcgplayer.com": "https://www.tcgplayer.com/product/88879",
                        "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=274324",
                        "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Sabrinas+Hypno+G2+%2356&_sacat=2536"
                    }
                },
                {
                    "set": "Surging Sparks",
                    "set_code": "SSP",
                    "card_number": "247",
                    "name": "Pikachu ex",
                    "out_of": "191",
                    "rarity": "Hyper Rare",
                    "series": "Scarlet & Violet",
                    "set_series_code": "sv7",
                    "year": 2024,
                    "full_name": "Pikachu ex Surging Sparks (SSP) #247",
                    "subcategory": "Pokemon",
                    "links": {
                        "tcgplayer.com": "https://www.tcgplayer.com/product/593169",
                        "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=794621",
                        "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Pikachu+ex+SSP+%23247&_sacat=2536"
                    }
                },
                {
                    "set": "Phantasmal Flames",
                    "set_code": "PFL",
                    "card_number": "43",
                    "name": "Milcery",
                    "out_of": "094",
                    "rarity": "Common",
                    "series": "Mega Evolution Series",
                    "year": 2025,
                    "full_name": "Milcery Phantasmal Flames (PFL) #43",
                    "subcategory": "Pokemon",
                    "links": {
                        "tcgplayer.com": "https://www.tcgplayer.com/product/662196",
                        "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=857618",
                        "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Milcery+PFL+%2343&_sacat=2536"
                    }
                },
                {
                    "set": "Mega Evolution",
                    "set_code": "MEG",
                    "card_number": "182",
                    "name": "Mega Kangaskhan ex",
                    "out_of": "132",
                    "rarity": "Special Illustration Rare",
                    "series": "Mega Evolution Series",
                    "year": 2025,
                    "full_name": "Mega Kangaskhan ex Mega Evolution (MEG) #182",
                    "subcategory": "Pokemon",
                    "links": {
                        "tcgplayer.com": "https://www.tcgplayer.com/product/654521",
                        "cardmarket.com": "https://www.cardmarket.com/en/Pokemon/Products?idProduct=851253",
                        "ebay.com": "https://www.ebay.com/sch/i.html?_nkw=Pokemon+Mega+Kangaskhan+ex+MEG+%23182&_sacat=2536"
                    }
                }
            ],
            "economics": {
                "raw_value": 480,
                "predicted_grade": 8,
                "graded_prices": {
                    "graded": 965,
                    "1": 27.013824000000014,
                    "1.0": 27.013824000000014,
                    "1.5": 34.874696823126094,
                    "2": 45.023040000000016,
                    "2.0": 45.023040000000016,
                    "2.5": 58.12449470521015,
                    "3": 75.03840000000002,
                    "3.0": 75.03840000000002,
                    "3.5": 96.8741578420169,
                    "4": 125.06400000000005,
                    "4.0": 125.06400000000005,
                    "4.5": 161.45692973669483,
                    "5": 208.44000000000005,
                    "5.0": 208.44000000000005,
                    "5.5": 269.0948828944914,
                    "6": 347.40000000000003,
                    "6.0": 347.40000000000003,
                    "6.5": 448.4914714908189,
                    "7": 579.0000000000001,
                    "7.0": 579.0000000000001,
                    "7.5": 747.4857858180314,
                    "8": 965,
                    "8.0": 965,
                    "8.5": 1181.8788008928834,
                    "9": 1447.4999999999998,
                    "9.0": 1447.4999999999998,
                    "9.5": 1772.8182013393248,
                    "10": 2171.249999999999,
                    "10.0": 2171.249999999999,
                    "best": 965
                },
                "options": [
                    {
                        "company": "CGC",
                        "tier": "Economy",
                        "fee": 20,
                        "total_cost": 51.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 913.7,
                        "roi_percent": 1781.1,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1396.2,
                        "turnaround_days": "90 working days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "CGC",
                        "tier": "Standard",
                        "fee": 55,
                        "total_cost": 86.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 878.7,
                        "roi_percent": 1018.2,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1361.2,
                        "turnaround_days": "10 working days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Standard",
                        "fee": 59.99,
                        "total_cost": 91.29,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 873.71,
                        "roi_percent": 957.1,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1356.21,
                        "turnaround_days": "90-100 business days",
                        "tags": "NEW — opens Sept 14, 2026; lowest active tier",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Priority",
                        "fee": 79,
                        "total_cost": 110.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 854.7,
                        "roi_percent": 774.9,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1337.2,
                        "turnaround_days": "70-80 business days",
                        "tags": "renamed from Regular; effective Sept 14, 2026",
                        "is_paused": false
                    },
                    {
                        "company": "CGC",
                        "tier": "Express",
                        "fee": 100,
                        "total_cost": 131.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 833.7,
                        "roi_percent": 635,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1316.2,
                        "turnaround_days": "5 working days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "TAG",
                        "tier": "Priority",
                        "fee": 149,
                        "total_cost": 180.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 784.7,
                        "roi_percent": 435.2,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1267.2,
                        "turnaround_days": "5 business days",
                        "tags": "limited availability",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Express",
                        "fee": 199,
                        "total_cost": 230.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 734.7,
                        "roi_percent": 319,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1217.2,
                        "turnaround_days": "20-30 business days",
                        "tags": "raised from $149; effective Sept 14, 2026",
                        "is_paused": false
                    },
                    {
                        "company": "TAG",
                        "tier": "Walkthrough",
                        "fee": 299,
                        "total_cost": 330.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 634.7,
                        "roi_percent": 192.2,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1117.2,
                        "turnaround_days": "2-3 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "CGC",
                        "tier": "WalkThrough",
                        "fee": 300,
                        "total_cost": 331.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 633.7,
                        "roi_percent": 191.3,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1116.2,
                        "turnaround_days": "2 working days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "CGC",
                        "tier": "Unlimited Value",
                        "fee": 300,
                        "total_cost": 331.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 633.7,
                        "roi_percent": 191.3,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1116.2,
                        "turnaround_days": "2 working days",
                        "tags": "active; +1% FMV",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Super Express",
                        "fee": 349,
                        "total_cost": 380.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 584.7,
                        "roi_percent": 153.7,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 1067.2,
                        "turnaround_days": "10-15 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "SGC",
                        "tier": "Standard ($1,500)",
                        "fee": 50,
                        "total_cost": 81.3,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": 497.7,
                        "roi_percent": 612.2,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": 883.7,
                        "turnaround_days": "40-50 business days",
                        "tags": "active; raised from $15 on Sep 2 2026",
                        "is_paused": false
                    },
                    {
                        "company": "BGS",
                        "tier": "Express",
                        "fee": 79.95,
                        "total_cost": 111.25,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": 467.75,
                        "roi_percent": 420.4,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": 853.75,
                        "turnaround_days": "15 business days",
                        "tags": "active; includes subgrades",
                        "is_paused": false
                    },
                    {
                        "company": "SGC",
                        "tier": "Standard ($3,500)",
                        "fee": 85,
                        "total_cost": 116.3,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": 462.7,
                        "roi_percent": 397.9,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": 848.7,
                        "turnaround_days": "40-50 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "BGS",
                        "tier": "Priority",
                        "fee": 124.95,
                        "total_cost": 156.25,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": 422.75,
                        "roi_percent": 270.6,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": 808.75,
                        "turnaround_days": "5 business days",
                        "tags": "active; includes subgrades",
                        "is_paused": false
                    },
                    {
                        "company": "SGC",
                        "tier": "Expedited ($3,500)",
                        "fee": 150,
                        "total_cost": 181.3,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": 397.7,
                        "roi_percent": 219.4,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": 783.7,
                        "turnaround_days": "2-3 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Premier",
                        "fee": 599,
                        "total_cost": 630.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": 334.7,
                        "roi_percent": 53.1,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 817.2,
                        "turnaround_days": "7-10 business days",
                        "tags": "renamed from Walk-Through; effective Sept 14, 2026",
                        "is_paused": false
                    },
                    {
                        "company": "SGC",
                        "tier": "Expedited ($7,500)",
                        "fee": 250,
                        "total_cost": 281.3,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": 297.7,
                        "roi_percent": 105.8,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": 683.7,
                        "turnaround_days": "2-3 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "SGC",
                        "tier": "Expedited ($20,000)",
                        "fee": 500,
                        "total_cost": 531.3,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": 47.7,
                        "roi_percent": 9,
                        "raw_value": 480,
                        "break_even": true,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": 433.7,
                        "turnaround_days": "2-3 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Premium 1",
                        "fee": 999,
                        "total_cost": 1030.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": -65.3,
                        "roi_percent": -6.3,
                        "raw_value": 480,
                        "break_even": false,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": 417.2,
                        "turnaround_days": "5-7 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "SGC",
                        "tier": "Expedited ($50,000)",
                        "fee": 1000,
                        "total_cost": 1031.3,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": -452.3,
                        "roi_percent": -43.9,
                        "raw_value": 480,
                        "break_even": false,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": -66.3,
                        "turnaround_days": "2-3 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Premium 2",
                        "fee": 1999,
                        "total_cost": 2030.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": -1065.3,
                        "roi_percent": -52.5,
                        "raw_value": 480,
                        "break_even": false,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": -582.8,
                        "turnaround_days": "5-7 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "SGC",
                        "tier": "Expedited ($100,000)",
                        "fee": 2000,
                        "total_cost": 2031.3,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": -1452.3,
                        "roi_percent": -71.5,
                        "raw_value": 480,
                        "break_even": false,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": -1066.3,
                        "turnaround_days": "2-3 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Premium 3",
                        "fee": 2999,
                        "total_cost": 3030.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": -2065.3,
                        "roi_percent": -68.2,
                        "raw_value": 480,
                        "break_even": false,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": -1582.8,
                        "turnaround_days": "5-7 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "SGC",
                        "tier": "Expedited ($100,000+)",
                        "fee": 3750,
                        "total_cost": 3781.3,
                        "best_grade": "7",
                        "best_value": 579,
                        "net_profit": -3202.3,
                        "roi_percent": -84.7,
                        "raw_value": 480,
                        "break_even": false,
                        "upside_grade": "8",
                        "upside_value": 965,
                        "upside_net": -2816.3,
                        "turnaround_days": "2-3 business days",
                        "tags": "active; +$375 per $10k over $100k",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Premium 5",
                        "fee": 4999,
                        "total_cost": 5030.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": -4065.3,
                        "roi_percent": -80.8,
                        "raw_value": 480,
                        "break_even": false,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": -3582.8,
                        "turnaround_days": "5-7 business days",
                        "tags": "active",
                        "is_paused": false
                    },
                    {
                        "company": "PSA",
                        "tier": "Premium 10",
                        "fee": 9999,
                        "total_cost": 10030.3,
                        "best_grade": "8",
                        "best_value": 965,
                        "net_profit": -9065.3,
                        "roi_percent": -90.4,
                        "raw_value": 480,
                        "break_even": false,
                        "upside_grade": "9",
                        "upside_value": 1447.5,
                        "upside_net": -8582.8,
                        "turnaround_days": "5-7 business days",
                        "tags": "active; +$399 per $10k over $350k",
                        "is_paused": false
                    }
                ],
                "best_option": {
                    "company": "CGC",
                    "tier": "Economy",
                    "fee": 20,
                    "total_cost": 51.3,
                    "best_grade": "8",
                    "best_value": 965,
                    "net_profit": 913.7,
                    "roi_percent": 1781.1,
                    "raw_value": 480,
                    "break_even": true,
                    "upside_grade": "9",
                    "upside_value": 1447.5,
                    "upside_net": 1396.2,
                    "turnaround_days": "90 working days",
                    "tags": "active",
                    "is_paused": false
                },
                "recommendation": "Submit to CGC (Economy)",
                "recommendation_reason": "Predicted 8 could net $913.70 after CGC fees, shipping, and insurance. Upside: if it grades 9, est. net $1,396.20.",
                "shipping_insurance": 12
            },
            "live_comps": {
                "query": "Pikachu ex Ascended Heroes (ASC)",
                "source": "SoldComps (eBay + Mercari) + eBay Browse API",
                "fair_value": 850,
                "confidence": "High",
                "fair_value_date": "2026-09-11",
                "fair_value_sales_90d": 142,
                "per_grade_ladder": {
                    "PSA 8": 850,
                    "PSA 9": 1200,
                    "PSA 10": 2400,
                    "BGS 9.5": 1100,
                    "CGC 9.5": 1050
                },
                "tcgplayer_prices": {
                    "market_price": 2.64,
                    "low_price": 1.00,
                    "mid_price": 2.15,
                    "high_price": 2.77
                },
                "graded_prices": {
                    "psa": { "10": 2400, "9": 1200, "8": 850 },
                    "bgs": { "9.5": 1100, "9": 700 },
                    "cgc": { "9.5": 1050, "9": 650 }
                },
                "population_report": {
                    "psa": { "10": 1524, "9": 892, "8": 456, "7": 213, "total": 3085 },
                    "cgc": { "10": 302, "9.5": 189, "9": 97, "total": 588 }
                },
                "cardmarket_floor_eur": 1.85,
                "cardmarket_trend_eur": 2.10,
                "cardmarket_avg7_eur": 2.05,
                "cardmarket_avg30_eur": 2.20,
                "parsebot_median": 2.15,
                "parsebot_avg": 2.32,
                "parsebot_low": 1.50,
                "parsebot_high": 4.25,
                "parsebot_count": 47,
                "parsebot_trend": "up",
                "parsebot_trend_pct": 3.2,
                "psa_population_set": "2026 Pokemon Ascended Heroes",
                "psa_population_subject": "Pikachu EX - Special Illustration Rare",
                "psa_population_total": 1247,
                "psa_population_set_total": 45892,
                "psa_population_by_grade": {
                    "1": 0, "2": 1, "3": 2, "4": 5, "5": 12, "6": 28, "7": 85, "8": 312, "9": 547, "10": 255
                },
                "psa_price_guide": {
                    "NM-MT 8": 35,
                    "MT 9": 120,
                    "GEM-MT 10": 680
                },
                "price_trends": {
                    "7d": { "pct": 0.3 },
                    "30d": { "pct": -5.42 },
                    "90d": { "pct": 2.91 }
                },
                "tcgpl_conditions": {
                    "mint": { "market": 3.10, "low": 1.50, "mid": 2.60, "high": 5.00 },
                    "near_mint": { "market": 2.64, "low": 1.00, "mid": 2.15, "high": 2.77 },
                    "lightly_played": { "market": 2.05, "low": 0.80, "mid": 1.75, "high": 2.30 },
                    "moderately_played": { "market": 1.45, "low": 0.55, "mid": 1.20, "high": 1.80 },
                    "heavily_played": { "market": 0.92, "low": 0.35, "mid": 0.80, "high": 1.10 },
                    "damaged": { "market": 0.41, "low": 0.15, "mid": 0.35, "high": 0.60 }
                },
                "csd_sell": {
                    "online": { "market_cents": 290 },
                    "show": { "market_cents": 335 },
                    "lcs": { "market_cents": 265 }
                },
                "csd_sales": {
                    "online": [
                        { "date": "2026-09-28", "price_cents": 275 },
                        { "date": "2026-09-20", "price_cents": 290 }
                    ],
                    "show": [
                        { "date": "2026-09-21", "price_cents": 320 }
                    ],
                    "graded": {
                        "psa": [
                            { "date": "2026-09-25", "grade": "10", "price_cents": 235000 },
                            { "date": "2026-09-12", "grade": "9", "price_cents": 114500 }
                        ],
                        "cgc": [
                            { "date": "2026-09-18", "grade": "9.5", "price_cents": 101000 }
                        ]
                    }
                },
                "csd_listings": {
                    "psa": [
                        { "grade": "10", "price_cents": 259000 },
                        { "grade": "9", "price_cents": 125000 }
                    ]
                },
                "csd_as_of": "2026-09-30",
                "cl_pct_30d": 4.7,
                "sold": [
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 9",
                        "price": 655,
                        "currency": "USD",
                        "priceText": "$655.00",
                        "soldDate": "Sep 5, 2026",
                        "itemUrl": "https://www.ebay.com/itm/377475315287",
                        "bestOffer": false,
                        "source": "eBay Sold (RapidAPI)"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 10",
                        "price": 2045,
                        "currency": "USD",
                        "priceText": "$2,045.00",
                        "soldDate": "Sep 6, 2026",
                        "itemUrl": "https://www.ebay.com/itm/307161549206",
                        "bestOffer": false,
                        "source": "eBay Sold (RapidAPI)"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 10",
                        "price": 860,
                        "currency": "USD",
                        "priceText": "$860.00",
                        "soldDate": "Sep 7, 2026",
                        "itemUrl": "https://www.ebay.com/itm/307158892395",
                        "bestOffer": false,
                        "source": "eBay Sold (RapidAPI)"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 10",
                        "price": 2225,
                        "currency": "USD",
                        "priceText": "$2,225.00",
                        "soldDate": "Sep 8, 2026",
                        "itemUrl": "https://www.ebay.com/itm/298642537955",
                        "bestOffer": false,
                        "source": "eBay Sold (RapidAPI)"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 9",
                        "price": 830,
                        "currency": "USD",
                        "priceText": "$830.00",
                        "soldDate": "Sep 9, 2026",
                        "itemUrl": "https://www.ebay.com/itm/298642586065",
                        "bestOffer": false,
                        "source": "eBay Sold (RapidAPI)"
                    },
                    {
                        "title": "Pikachu ex - 277/217 - ME: Ascended Heroes (ASC)",
                        "price": 360,
                        "currency": "USD",
                        "priceText": "$360.00",
                        "soldDate": "Sep 10, 2026",
                        "itemUrl": "https://www.ebay.com/itm/206532478337",
                        "bestOffer": false,
                        "source": "eBay Sold (RapidAPI)"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 9",
                        "price": 800,
                        "currency": "USD",
                        "priceText": "$800.00",
                        "soldDate": "Sep 10, 2026",
                        "itemUrl": "https://www.ebay.com/itm/117392073795",
                        "bestOffer": false,
                        "source": "eBay Sold (RapidAPI)"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 9",
                        "price": 800,
                        "currency": "USD",
                        "priceText": "$800.00",
                        "soldDate": "Sep 11, 2026",
                        "itemUrl": "https://www.ebay.com/itm/298639362740",
                        "bestOffer": false,
                        "source": "eBay Sold (RapidAPI)"
                    }
                ],
                "active": [
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX",
                        "price": 325,
                        "currency": "USD",
                        "itemUrl": "https://www.ebay.com/itm/298662188197?_skw=Pikachu+ex+Ascended+Heroes+%28ASC%29&hash=item4589a754a5:g:KS0AAeSwSrhqot~8",
                        "imageUrl": "https://i.ebayimg.com/images/g/KS0AAeSwSrhqot~8/s-l225.jpg",
                        "condition": "Ungraded",
                        "buyingOptions": [
                            "FIXED_PRICE"
                        ],
                        "sellerName": "ig_slabspaceirvine",
                        "source": "eBay"
                    },
                    {
                        "title": "Pokemon 🔥 Pikachu ex - 277/217 - ME: Ascended Heroes (ASC) SIR Mint/NM CLEAN",
                        "price": 315,
                        "currency": "USD",
                        "itemUrl": "https://www.ebay.com/itm/407209896060?_skw=Pikachu+ex+Ascended+Heroes+%28ASC%29&hash=item5ecf99e87c:g:8wsAAeSwJVJqpFAS&amdata=enc%3AAQALAAABAACCtXRWQnOEpyOqnQQ8KGZ%2F5fXkxbKGVMjFlHtezbuEO1bQjujE%2BfBK7dNJsarPQOUDSfDYcewm2%2BBiXhBDmPj280e7JaZkd8pYhe043avDXC3wGFqgcj4cobOCYz4y1nDEV79bVl%2BR5sLqSnSD7m4%2FSEw154d7w9pdYBmelQDn5GFbTRCwOciwl%2Fq%2FZNi2JghZxYbLfVChhw6SXI0lQ%2FJi2s7DR5bpA%2FrjKeaZaNc%2FDGgkIrCVneIYrI0Z721XBfQe0tPPBN46QMlTjI78AxaGXe8kdEi9ukVwX%2BURu8elyhz5R8QvolgCsAdy7q4sJs%2BKqZa3ch0lI7rRxaAfyVQ%3D",
                        "imageUrl": "https://i.ebayimg.com/images/g/8wsAAeSwJVJqpFAS/s-l225.jpg",
                        "condition": "Ungraded",
                        "buyingOptions": [
                            "FIXED_PRICE",
                            "BEST_OFFER"
                        ],
                        "sellerName": "miha_164738",
                        "source": "eBay"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 10",
                        "price": 845,
                        "currency": "USD",
                        "itemUrl": "https://www.ebay.com/itm/307173587198?_skw=Pikachu+ex+Ascended+Heroes+%28ASC%29&hash=item4784f8f8fe:g:7VgAAeSwcFNqo-av",
                        "imageUrl": "https://i.ebayimg.com/images/g/7VgAAeSwcFNqo-av/s-l225.jpg",
                        "condition": "Graded",
                        "buyingOptions": [
                            "FIXED_PRICE",
                            "BEST_OFFER"
                        ],
                        "sellerName": "psa",
                        "source": "eBay"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 8",
                        "price": 299,
                        "currency": "USD",
                        "itemUrl": "https://www.ebay.com/itm/117393507310?_skw=Pikachu+ex+Ascended+Heroes+%28ASC%29&hash=item1b5532c3ee:g:Zu8AAeSwwTlqmWs0",
                        "imageUrl": "https://i.ebayimg.com/images/g/Zu8AAeSwwTlqmWs0/s-l225.jpg",
                        "condition": "Graded",
                        "buyingOptions": [
                            "FIXED_PRICE"
                        ],
                        "sellerName": "psa",
                        "source": "eBay"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 10",
                        "price": 2099.99,
                        "currency": "USD",
                        "itemUrl": "https://www.ebay.com/itm/298665990752?_skw=Pikachu+ex+Ascended+Heroes+%28ASC%29&hash=item4589e15a60:g:MEoAAeSwqvhqn55Y",
                        "imageUrl": "https://i.ebayimg.com/images/g/MEoAAeSwqvhqn55Y/s-l225.jpg",
                        "condition": "Graded",
                        "buyingOptions": [
                            "FIXED_PRICE"
                        ],
                        "sellerName": "psa",
                        "source": "eBay"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 10",
                        "price": 2149,
                        "currency": "USD",
                        "itemUrl": "https://www.ebay.com/itm/298666312831?_skw=Pikachu+ex+Ascended+Heroes+%28ASC%29&hash=item4589e6447f:g:vM8AAeSwbmZqpQo8",
                        "imageUrl": "https://i.ebayimg.com/images/g/vM8AAeSwbmZqpQo8/s-l225.jpg",
                        "condition": "Graded",
                        "buyingOptions": [
                            "FIXED_PRICE",
                            "BEST_OFFER"
                        ],
                        "sellerName": "psa",
                        "source": "eBay"
                    },
                    {
                        "title": "2026 POKEMON ASC EN-ASCENDED HEROES SPECIAL ILLUSTRATION RARE PIKACHU EX PSA 10",
                        "price": 2175,
                        "currency": "USD",
                        "itemUrl": "https://www.ebay.com/itm/298664937501?_skw=Pikachu+ex+Ascended+Heroes+%28ASC%29&hash=item4589d1481d:g:irkAAeSwikBqoOKg",
                        "imageUrl": "https://i.ebayimg.com/images/g/irkAAeSwikBqoOKg/s-l225.jpg",
                        "condition": "Graded",
                        "buyingOptions": [
                            "FIXED_PRICE"
                        ],
                        "sellerName": "psa",
                        "source": "eBay"
                    },
                    {
                        "title": "PIKACHU EX 057/217 ASCENDED HEROES POKEMON HOLO NM/M ASC",
                        "price": 5,
                        "currency": "USD",
                        "itemUrl": "https://www.ebay.com/itm/267780989416?_skw=Pikachu+ex+Ascended+Heroes+%28ASC%29&hash=item3e58fda1e8:g:0AMAAeSwIp1qofnb",
                        "imageUrl": "https://i.ebayimg.com/images/g/0AMAAeSwIp1qofnb/s-l225.jpg",
                        "condition": "Ungraded",
                        "buyingOptions": [
                            "FIXED_PRICE"
                        ],
                        "sellerName": "yellowalligatormarketspace",
                        "source": "eBay"
                    }
                ],
                "summary": {
                    "sold_count": 60,
                    "active_count": 20,
                    "sold_avg": 933.76,
                    "sold_median": 860,
                    "sold_low": 4.18,
                    "sold_high": 2400,
                    "sold_currency": "USD",
                    "active_low": 4.74,
                    "active_high": 2224.99,
                    "active_median": 872.5,
                    "active_avg": 950.4094999999998,
                    "active_currency": "USD"
                }
            },
            "tcg_card_data": {
                "success": true,
                "card": [{
                    "game": "Pokemon",
                    "name": "Pikachu ex",
                    "supertype": "Pokémon",
                    "subtypes": ["Basic", "EX"],
                    "hp": "200",
                    "types": ["Lightning"],
                    "rarity": "Illustration Rare",
                    "set_name": "Ascended Heroes",
                    "set_id": "sv1",
                    "set_series": "Scarlet & Violet",
                    "set_logo": "https://images.pokemontcg.io/sv1/logo.png",
                    "set_symbol": "https://images.pokemontcg.io/sv1/symbol.png",
                    "set_total": 258,
                    "number": "277",
                    "artist": "5ban Graphics",
                    "year": "2026/01/01",
                    "tcgplayer_url": "https://prices.pokemontcg.io/tcgplayer/sv1-250",
                    "cardmarket_url": "https://prices.pokemontcg.io/cardmarket/sv1-250",
                    "source": "Pokemon TCG API"
                }],
                "source": "multi"
            },
            "image_quality": {
                "overall_quality": "good",
                "score": 91,
                "framing": "good",
                "card_frame_pct": 74,
                "lighting": "good",
                "has_glare": false,
                "is_blurry": false,
                "has_shadows": false,
                "background": "clean",
                "has_sleeve": false,
                "has_hands": false,
                "is_slabbed": false,
                "has_relic": false,
                "relic_type": "none",
                "relic_colors": [],
                "has_autograph": false,
                "is_numbered": false,
                "serial": null,
                "issues_found": [],
                "observed_defects": [],
                "commentary": "Sharp, well-lit photo with the card filling most of the frame. No glare, blur, or shadows detected."
            }
        },
        condition: {
            _status: MOCK_STATUS,
            _id: 'preview-condition',
            _width: 1200,
            _height: 1600,
            _processing_time: 1800,
            condition: { label: 'Excellent', value: 8.2, mode: 'majority' },
            damaged: { is_damaged: false, value: 'OK', confidence: 0.97 },
            detection: { name: 'Card', confidence: 0.96, bound_box: [30, 40, 1180, 1560] },
            category: { name: 'Card/Sport Card', value: 'Card/Sport Card', confidence: 0.99 },
            side: { value: 'front', confidence: 0.98 },
            autograph: { has_autograph: false, value: 'No', confidence: 0.99 },
            card_type: 'Base',
            versions: { service: 'preview/1.0' }
        },
        centering: {
            _status: MOCK_STATUS,
            _id: 'preview-centering',
            _width: 1200,
            _height: 1600,
            _processing_time: 1500,
            centering: {
                grade: 8,
                left_right: '51/49',
                top_bottom: '50/50',
                offsets: [0.0442, 0.0378, 0.0429, 0.0371],
                margins: { left: 51, right: 49, top: 50, bottom: 50 }
            },
            card: {
                _tags: {
                    Side: [{ name: 'front', prob: 0.98 }],
                    Category: [{ name: 'Card/Sport Card', prob: 0.99 }]
                }
            },
            side: { value: 'front', confidence: 0.98 },
            category: { value: 'Card/Sport Card', confidence: 0.99 },
            autograph: { has_autograph: false, value: 'No', confidence: 0.99 },
            versions: { service: 'preview/1.0' }
        },
        crop: {
            _status: MOCK_STATUS,
            _id: 'preview-crop',
            _width: 1100,
            _height: 1520,
            _processing_time: 900,
            _img_url: CROP_EXAMPLE_BEFORE,
            original_image_url: CROP_EXAMPLE_BEFORE,
            cropped_image_base64: CROP_EXAMPLE_AFTER,
            _images: {
                original: CROP_EXAMPLE_BEFORE,
                visualization: CROP_EXAMPLE_AFTER
            },
            crop_level: 'tight',
            card_detected: true,
            versions: { service: 'preview/1.0' }
        },
        localize: {
            _status: MOCK_STATUS,
            _id: 'preview-localize',
            _width: 1200,
            _height: 1600,
            _processing_time: 1100,
            detection: { name: 'Card', confidence: 0.96, bound_box: [30, 40, 1180, 1560] },
            card: { _tags: { Category: [{ name: 'Card/Sport Card', prob: 0.99 }] } },
            corners: [
                { name: 'top_left', x: 30, y: 40 },
                { name: 'top_right', x: 1180, y: 40 },
                { name: 'bottom_right', x: 1180, y: 1560 },
                { name: 'bottom_left', x: 30, y: 1560 }
            ],
            edges: [
                { name: 'top', length: 1150 },
                { name: 'right', length: 1520 },
                { name: 'bottom', length: 1150 },
                { name: 'left', length: 1520 }
            ],
            _img_url: BASE_CARD_IMG,
            _full_url_card: BASE_CARD_IMG,
            visualization_url: BASE_CARD_IMG,
            versions: { service: 'preview/1.0' }
        },
        'sport-id': {
            _status: MOCK_STATUS,
            _id: 'preview-sport-id',
            _width: 1200,
            _height: 1600,
            _processing_time: 2800,
            card: {
                identification: MOCK_IDENTIFICATION,
                listings: MOCK_LISTINGS,
                price_stats: [MOCK_PRICING.graded, MOCK_PRICING.ungraded, MOCK_PRICING.overall]
            },
            versions: { service: 'preview/1.0' }
        },
        'slab-id': {
            _status: MOCK_STATUS,
            _id: 'preview-slab-id',
            _width: 1200,
            _height: 1600,
            _processing_time: 2400,
            identification: {
                full_name: 'Wayne Gretzky 1979 Topps #18 PSA 6',
                name: 'Wayne Gretzky 1979 Topps #18',
                year: '1979',
                set: 'Topps',
                card_no: '18',
                company: 'Topps',
                grade: '6',
                verbal_grade: 'Excellent-Mint',
                certificate_number: '119675168',
                links: { 'PSA': 'https://www.psacard.com' }
            },
            slab: {
                company: { name: 'PSA' },
                confidence: 0.98
            },
            ocr: {
                full_text: 'PSA\n1979 TOPPS #18\nWAYNE GRETZKY\nEX-MT 6\n119675168',
                lang_name: 'English',
                texts: [
                    { text: 'PSA' },
                    { text: '1979 TOPPS #18' },
                    { text: 'WAYNE GRETZKY' },
                    { text: 'EX-MT 6' },
                    { text: '119675168' }
                ]
            },
            card: {
                _tags: { Category: [{ name: 'Card/Sport Card', prob: 0.99 }] }
            },
            versions: { service: 'preview/1.0' }
        },
        'slab-grade': {
            _status: MOCK_STATUS,
            _id: 'preview-slab-grade',
            _width: 1200,
            _height: 1600,
            _processing_time: 2600,
            slab: {
                company: { name: 'PSA', confidence: 0.98 },
                grade: { value: 10, confidence: 0.91 },
                category: { name: 'Card/Sport Card' },
                side: { name: 'front' }
            },
            graded_slab: {
                company: 'PSA',
                grade: 10,
                category: 'Card/Sport Card'
            },
            identification: {
                full_name: 'Shohei Ohtani 2023 Panini Prizm Downtown PSA 10',
                name: 'Shohei Ohtani 2023 Panini Prizm Downtown',
                year: '2023',
                set: 'Panini Prizm',
                card_no: null,
                company: 'Panini',
                grade: '10',
                verbal_grade: 'Gem Mint',
                certificate_number: null
            },
            card: {
                bound_box: [40, 60, 1160, 1540],
                _tags: { Category: [{ name: 'Card/Sport Card', prob: 0.99 }] }
            },
            slab_detected: true,
            versions: { service: 'preview/1.0' }
        }
    };

    const creditMap = {
        grade: 20,
        condition: 4,
        centering: 4,
        crop: 2,
        localize: 2,
        'sport-id': 5,
        'slab-id': 15,
        'slab-grade': 5
    };

    function getMockRecord(service) {
        return mocks[service] || mocks.grade;
    }

    function getCreditsUsed(service) {
        return creditMap[service] || 5;
    }

    function getOriginalImageUrl(service, cardType) {
        if (service === 'crop') return CROP_EXAMPLE_BEFORE;
        if (SERVICE_IMAGES[service]) return SERVICE_IMAGES[service];
        if (cardType && CARD_TYPE_IMAGES[cardType]) return CARD_TYPE_IMAGES[cardType];
        return BASE_CARD_IMG;
    }

    function renderPreview(service, containerId, cardType) {
        const container = typeof containerId === 'string' ? document.getElementById(containerId) : containerId;
        if (!container) return;
        if (!window.XimilarResults || typeof window.XimilarResults.render !== 'function') {
            // ximilar-results.js didn't finish evaluating (or failed to load)
            // before this call — retry once on window load, then give up
            // quietly instead of beaconing a TypeError.
            if (!container.dataset.mockRetry) {
                container.dataset.mockRetry = '1';
                window.addEventListener('load', function () {
                    renderPreview(service, container, cardType);
                }, { once: true });
            }
            return;
        }
        container.setAttribute('data-mock-preview', '1');
        const record = getMockRecord(service);
        const credits = getCreditsUsed(service);
        const stats = { 'processing time': 1.5 };
        const meta = {};
        if (record.economics) meta.economics = record.economics;
        // Dev/QA hook: ?comps_pending (or window.PGC_MOCK_COMPS_PENDING) puts the
        // mock live_comps into the post-persist "still collecting" state so the
        // static pending banner path can be exercised end to end.
        let mockPending = false, mockPendingEmpty = false;
        try {
            const pv = new URLSearchParams(location.search).get('comps_pending');
            mockPending = !!window.PGC_MOCK_COMPS_PENDING || pv != null;
            mockPendingEmpty = pv === 'empty';
        } catch (e) {}
        if (mockPending && record.live_comps) {
            record.live_comps = mockPendingEmpty
                ? { comps_pending: true, query: 'mock', sold: [], active: [], summary: {} }
                : Object.assign({ comps_pending: true }, record.live_comps);
            meta.share_token = 'pending-demo';
        }
        embedMockPopulation(record);
        const html = window.XimilarResults.render(service, record, getOriginalImageUrl(service, cardType), credits, stats, meta);
        container.innerHTML = html;
    }

    // Flatten the mock's static live_comps.population_report ({company:
    // {grade: count, total}}) into record.population_records so the snapshot
    // panel mount renders it — mock previews never hit the population API.
    function embedMockPopulation(record) {
        if (record.population_records) return;
        const pop = (record.live_comps && record.live_comps.population_report)
            || record.population_report || null;
        if (!pop) return;
        const cardName = (record.live_comps && record.live_comps.psa_population_subject)
            || (record.card && record.card.name) || 'Card';
        const records = [];
        Object.keys(pop).forEach(company => {
            const grades = pop[company];
            const total = parseInt(grades.total) || 0;
            Object.keys(grades).forEach(g => {
                if (g === 'total') return;
                const pop10 = parseInt(grades['10']) || 0;
                records.push({
                    company: company.toUpperCase(),
                    grade: g,
                    population: grades[g],
                    total_graded: total,
                    gem_rate: total > 0 ? Math.round((pop10 / total) * 100) : null,
                    card_name: cardName,
                });
            });
        });
        if (records.length) record.population_records = records;
    }

    function renderToString(service, cardType) {
        const record = getMockRecord(service);
        const credits = getCreditsUsed(service);
        const stats = { 'processing time': 1.5 };
        const meta = {};
        if (record.economics) meta.economics = record.economics;
        embedMockPopulation(record);
        return window.XimilarResults.render(service, record, getOriginalImageUrl(service, cardType), credits, stats, meta);
    }

    window.MockResults = {
        render: renderPreview,
        renderToString: renderToString,
        getMockRecord: getMockRecord,
        getCreditsUsed: getCreditsUsed,
        getOriginalImageUrl: getOriginalImageUrl,
        CARD_TYPE_IMAGES: CARD_TYPE_IMAGES,
        mocks: mocks
    };
})(window);
